import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { DropdownWidth } from '../../../common/dropdown/dropdown.component';

@Component({
  selector: 'rt-time-zone-picker-dropdown',
  templateUrl: 'time-zone-picker-dropdown.component.html',
  styleUrls: ['./time-zone-picker-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeZonePickerDropdownComponent {
  @Output() public close: EventEmitter<void> = new EventEmitter();
  @Output() public zoneSelect: EventEmitter<string> = new EventEmitter();

  public DropdownWidth = DropdownWidth;
}
